import React, {useState} from 'react'
import axios from 'axios'
import {faceBookPixel} from "@common-helpers/face-book-pixel"
import {tiktokPixel} from "@common-helpers/tik-tok-pixel"
import countries from  './countries.json'
import {lockSubmitBtn, unlockSubmitBtn} from './heplers/submit-btn-availability'
import {CardCvcElement, CardExpiryElement, CardNumberElement, useElements, useStripe} from "@stripe/react-stripe-js";
import {createSubscription} from "@common-helpers/stripe-pay-functions"
import {setPathForRouter} from "@common-helpers/set-rout-path"


import masterCardUrl from "./img/credit-card.svg";


import stripeStyles from './options'

import Info from './img/info.svg'
import {getNextDay} from 'date-helper-js';

const stripeCustomElementStyles ={
    padding: '0 10px',
    boxSizing: 'border-box',
    width: '100%',
    border: '1px solid #EAEBF4',
    borderRadius: '10px',
    height: '43.59px',
    fontWeight: 600,
    color: '#4A4A4A',
    fontFamily: 'Open Sans, sans-serif',
    fontSize: '18px'
};

export const CardForm = ({block, nextRout, nextPageId, openModalHandler}) => {
    const stripe = useStripe(),
          elements = useElements(),
          [error, setError] = useState(''),
          [loading, setLoading] = useState(false),
          [postalCode, setPostalCode] = useState(''),
          [countryCode, setCountryCode] = useState('US'),
          isStripeHasError = error.length > 0,
          showNextComponent = setPathForRouter(nextRout, nextPageId),
          trialFinishDate = getNextDay(new Date(), 7),
          trialFinishDateTxt = `${trialFinishDate.getDate()}/${trialFinishDate.getMonth()+1}/${trialFinishDate.getFullYear()}`,
          handleSubmit = async (e) => {
            e.preventDefault();
            if (!postalCode.trim()) {
                setError('Postal code is required.');
                return false;
            }

              lockSubmitBtn()
              setLoading(() => true)

            try {

                const {data} = await axios.post(`/payment-form-data`, {}, {
                        headers: {
                            'x-requested-with': 'XMLHttpRequest',
                            'content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
                        }
                    }),
                    {priceId, customerEmail} = data


                if (!stripe || !elements) return


                const cardElement = elements.getElement(CardNumberElement);

                const {error, paymentMethod} = await stripe.createPaymentMethod({
                    type: 'card',
                    card: cardElement,
                    billing_details: {
                        name: customerEmail,
                        email: customerEmail,
                        address: {
                            country: countryCode,
                            postal_code: postalCode,
                        }
                    }
                });

                if (error) {

                    setLoading(() => false)
                    unlockSubmitBtn()
                    setError(error.message)

                } else {

                    createSubscription({
                        stripe,
                        paymentMethod: paymentMethod,
                        priceId: priceId,
                        errorCallback: (errorMessage = 'Something went wrong') => {

                            setLoading(() => false)
                            unlockSubmitBtn()
                            setError(errorMessage)
                        },
                        successCallback: () => {
                            let price = localStorage.getItem('trialPrice') || 0.00

                            faceBookPixel('track', 'Purchase', {'external_id': localStorage.getItem('click_id'), value: price, currency: 'EUR'})
                            tiktokPixel('CompletePayment', {price: price, currency: 'EUR'})

                            localStorage.removeItem('lang')
                            window.location.href = '/'
                            // showNextComponent()
                        }
                    });

                }

            } catch (error) {
                setLoading(() => false)
                unlockSubmitBtn()
                setError('Something went wrong')
            }



    }

    const date = new Date()
    const options = {
        hour: 'numeric',
        minute: 'numeric',
        hour12: false
    };
    const time = new Intl.DateTimeFormat('en-US', options).format(date)


    return (<>

        {isStripeHasError ? <p className="input__error stripe-form-error">{error}</p> : null}

        <div className="package__pay-inner-body">

            <label htmlFor="">Card number</label>
            <div className="input__outer stripe-input">

                <CardNumberElement options={{
                    style: stripeStyles
                }} />

                <div className="input__outer-visa">
                    <img src={masterCardUrl} alt="" />
                </div>

            </div>

            <div className="input__space-row">
                <div className="input__space-column">

                    <label htmlFor="">Validity</label>

                    <div className="input__outer stripe-input">

                        <CardExpiryElement options={{
                            style: stripeStyles
                        }}/>

                    </div>

                </div>
                <div style={{width: '8px'}}/>
                <div className="input__space-column">
                    <label htmlFor="">Security code</label>

                    <div className="input__outer stripe-input">

                        <CardCvcElement options={{
                            style: stripeStyles
                        }}/>

                    </div>

                </div>
            </div>
            <div className="input__space-row">
                <div className="input__space-column">
                    <label htmlFor="country">Country</label>
                    <div className="input__outer">
                        <select
                            id="country"
                            style={stripeCustomElementStyles}
                            value={countryCode}
                            onChange={(e) => setCountryCode(e.target.value)}
                        >
                            {countries.map(country => (
                                <option key={country.key} value={country.key}>
                                    {country.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div style={{width: '8px'}}/>
                <div className="input__space-column">
                    <label htmlFor="postal-code">Postal code</label>
                    <div className="input__outer">
                        <input
                            type="number"
                            max='5'
                            id="postal-code"
                            style={stripeCustomElementStyles}
                            value={postalCode}
                            onChange={(e) => setPostalCode(e.target.value)}
                            placeholder="e.g. 10001"
                        />
                    </div>
                </div>
            </div>
        </div>
            <div className={'text-row'}>
            <img src={Info} alt=""/>

            <p>
                By paying here you authorise automatically charges
            </p>
        </div>

        <button id={'continue-btn'} className={`btn__next ${block('start-btn')} ${block('y-offset')}`}
                onClick={handleSubmit}
        >
            <span>Pay {localStorage.getItem('trialPrice') || 0.00} eur</span>
        </button>

        <div className={'text-row text-row_last'}>

            <p>
                By clicking the button, you accept the <a href={'/terms'} onClick={openModalHandler}>terms of service</a>
            </p>
        </div>

    </>)

}
